import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=957c007e&"
import script from "./ProductHeader.vue?vue&type=script&lang=js&"
export * from "./ProductHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('957c007e')) {
      api.createRecord('957c007e', component.options)
    } else {
      api.reload('957c007e', component.options)
    }
    module.hot.accept("./ProductHeader.vue?vue&type=template&id=957c007e&", function () {
      api.rerender('957c007e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/battery-store/products/ProductHeader.vue"
export default component.exports